import {
  activateService,
  assignCapabilityToService,
  assignFleetToService,
  deactivateService,
  deleteFleetToService,
  fetchServiceDetails,
  fetchServices,
} from "@/ServerActions/service";
import { ApiService, DataResponse, ServiceDetails } from "@/types";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

export const useService = () => {
  return useQuery<DataResponse<ApiService[]>>({
    queryKey: ["service-list", "DotAdmin"], // ✅ FIXED
    queryFn: () => fetchServices(),
    staleTime: 300000,
  });
};

export const useServiceDetails = (service_id: string) => {
  return useQuery<DataResponse<ServiceDetails[]>>({
    queryKey: ["service-details", "DotAdmin", service_id],
    queryFn: () => fetchServiceDetails(service_id),
    enabled: Boolean(service_id),
  });
};

export const useEnableService = () => {
  const queryClient: any = useQueryClient();
  return useMutation({
    mutationFn: activateService,
    onSuccess: (_data, variables) => {
      const serviceId = variables?.service_id;

      queryClient.invalidateQueries({
        queryKey: ["service-details", "DotAdmin", serviceId],
      });

      queryClient.invalidateQueries({
        queryKey: ["service-list", "DotAdmin"],
      });
    },
    onError: (error) => {
      console.log(error);
    },
  });
};

export const useDisableService = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deactivateService,

    onSuccess: (_data, variables) => {
      const serviceId = variables?.service_id;

      queryClient.invalidateQueries({
        queryKey: ["service-details", "DotAdmin", serviceId],
      });

      queryClient.invalidateQueries({
        queryKey: ["service-list", "DotAdmin"],
      });
    },
  });
};

export const useAssignCapabilityToServiceMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: assignCapabilityToService,

    onSuccess: (_data, variables) => {
      const serviceId = variables?.service_id;

      queryClient.invalidateQueries({
        queryKey: ["service-details", "DotAdmin", serviceId],
      });
    },
  });
};

export const useAssignFleetToServiceMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: assignFleetToService,

    onSuccess: (_data, variables) => {
      const serviceId = variables?.service_id;

      queryClient.invalidateQueries({
        queryKey: ["service-details", "DotAdmin", serviceId],
      });
    },
  });
};
export const useDeleteFleetToServiceMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteFleetToService,

    onSuccess: (_data, variables) => {
      const serviceId = variables?.service_id;

      queryClient.invalidateQueries({
        queryKey: ["service-details", "DotAdmin", serviceId],
      });
    },
  });
};
